// extracted by mini-css-extract-plugin
export default {"ThinkingInput":"ThinkingInput_ThinkingInput__j30-O","home-icon":"ThinkingInput_home-icon__7+Z3U","FeedSearchQuery":"ThinkingInput_FeedSearchQuery__s0WFV"};